'use client';

import { getColorway, getYMargins } from 'utils/styles';
import { HubSpotProps } from './types';
import { Colorways, Margins } from 'types/constants';
import RichTextHeadline from 'components/shared/RichTextHeadline/RichTextHeadline';
import { liveUpdateAttrs } from 'libs/contentful/utils';
import { useHubSpotForm } from './useHubSpotForm';

const HubSpotBaseVariant = ({ sys, sectionName, headline, formId, color = Colorways.Inverse }: HubSpotProps) => {
  const margins = Margins.Centered;
  const { iframeRef, tagsUrl } = useHubSpotForm(formId, sys?.id);

  return (
    <section
      {...(sectionName != null && { id: encodeURIComponent(sectionName) })}
      className={`content-wrapper ${getYMargins(margins)} ${getColorway(color)}`}>
      {headline && (
        <div
          className="font-sans font-semibold text-heading-md md:text-heading-lg text-lettuce mb-12 md:w-3/4 md:pr-12"
          {...liveUpdateAttrs(sys?.id, 'headline')}>
          <RichTextHeadline headline={headline} />
        </div>
      )}
      <div
        className="bg-bg-primary p-6 text-content-primary font-serif text-body-serif"
        {...liveUpdateAttrs(sys?.id, 'formId')}>
        {tagsUrl && (
          <iframe
            ref={iframeRef}
            title="HubSpot"
            id={`hubspot-iframe-${sys?.id}`}
            src={tagsUrl}
            sandbox="allow-scripts allow-forms allow-same-origin allow-top-navigation allow-popups allow-popups-to-escape-sandbox"
            style={{
              width: '100%',
              height: '500px',
              border: 0,
              scrollMargin: '100px',
            }}
            data-testid="hubspotFormContainer"
          />
        )}
      </div>
    </section>
  );
};

export default HubSpotBaseVariant;
